<template>
  <!-- 账号密码截图 -->
  <div class="page_win reconiseInfoTip">
    <div class="head"><span>温馨提示</span></div>
    <div class="msg">
      <span class="">请阅读同意</span
      ><span
        class="textColor"
        @click="
          isShowAgreement = true;
          ruleType = 'agr';
        "
        >《用户协议》</span
      >和<span
        class="textColor"
        @click="
          isShowAgreement = true;
          ruleType = 'pri';
        "
        >《隐私协议》</span
      >
    </div>
    <div class="botBox" @click="closeAgrWin">
      <span>确认</span>
    </div>
    <div class="agrBox" v-if="isShowAgreement">
      <agreement class="agrCon" :type="ruleType" />
      <div
        class="closeAgr"
        @click="
          isShowAgreement = false;
          ruleType = '';
        "
      >
        <img :src="closeImg" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import agreement from "../../components/agreement.vue";

export default {
  components: { agreement },

  props: ["", ""],
  inject: ["reload"],
  data() {
    return {
      closeImg: require("../../assets/img/new2/close.png"), // 关闭
      isShowAgreement: false,
      ruleType: "agr",
    };
  },
  creater() {},
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("userInfo"));
  },
  methods: {
    closeAgrWin() {
      this.$store.dispatch("IsAgreementTipFun", false);
    },
    quitAccount() {
      this.$store.commit("postPwdLoginTitle", "继续登录");
      this.$store.dispatch("IsReconiseInfoTipFun", false);
      this.$store.dispatch("IsLoginBoxFun", true);
    },
    goReconiseInfo() {
      this.$store.dispatch("IsReconiseInfoTipFun", false);
      this.$store.dispatch("IsReconiseInfoFun", true);
    },
  },
};
</script>
<style  lang="scss" scoped>
@mixin flex_box(
  $flex-direction: row,
  $justify-content: none,
  $align-items: none
) {
  display: flex;
  flex-direction: $flex-direction;
  justify-content: $justify-content;
  align-items: $align-items;
}
.reconiseInfoTip {
  padding: 0.3rem 0.4rem;
  width: 5.4rem;
  z-index: 10;
}
.head {
  @include flex_box(row, center, center);
  color: #ff913a;
  font-size: 16px;
  font-weight: bold;
}

.msg {
  margin: 0.5rem 0;
  color: #838383;
  font-size: 12px;
  text-align: center;
  span {
    line-height: 0.3rem;
  }
}
.textColor {
  color: #ff913a;
}
.botBox {
  background-color: #ff913a;
  color: #fff;
  font-size: 14px;
  height: 0.68rem;
  @include flex_box(row, center, center);
  border-radius: 0.1rem;
  span {
    letter-spacing: 2px;
  }
}
.agrBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
}
.agrCon {
  width: 100%;
  height: 100%;
}
.closeAgr {
  position: absolute;
  right: 0;
  top: 0;
  width: 0.6rem;
  height: 0.6rem;
  @include flex_box(row, center, center);
  img {
    width: 0.3rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/view8/agreementTip.vue